module.exports = __webpack_public_path__ + "static-portal/img/jr05.dc72bf3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jr05.jpg
// module id = AtYa
// module chunks = 4